import React, { useContext, useEffect, useState } from 'react'
import {
  isTripDetailsPage,
  getTripIdForApp,
  validatePhone,
  emailValidator,
  getCommonClevertapParams,
  triggerClevertap,
  updateOptionsLevel,
  formatDate
} from 'AccountsUtils'
import { AccountsContext } from 'AccountsContext'
import OptionsBox from '../OptionsBox'
import TripLabel from '../TripLabel'
import SelectedOption from '../SelectedOption'
import Modal from '../Modal'
import './SupportBody.css'
import AirlineInfo from '../AirlineInfo'

const inputMap = { phone: { msg: '* Please enter a valid phone number', validator: validatePhone }, email: { msg: '* Please enter a valid email', validator: emailValidator } }
const RequestCallbackModal = props => {
  const { initialValue,
    callbackInput,
    showInputError,
    validateAndSetInput,
    message,
    supportInputType } = props
  useEffect(() => {
    validateAndSetInput(initialValue, supportInputType)
  }, [initialValue])
  return (
    <React.Fragment>
      <div>
        {message}
      </div>
      <div className="flex flex-center amt-10 mt10 apr-20 apl-20">
        <input
          type="text"
          value={callbackInput}
          className={showInputError ? 'input-callback error-input' : 'input-callback'}
          onInput={e => validateAndSetInput(e.target.value, supportInputType)}
        />
      </div>
      <div
        className={showInputError ? 'error-message apr-20 pb-2' : 'error-message o-0'}
      >{(inputMap && inputMap[supportInputType] && inputMap[supportInputType].msg) || ''}
      </div>
    </React.Fragment>
  )
}

const EscalationsModal = props => {
  const { complaintInput,
    showComplaintError,
    validateComplaint,
    message,
    isDirty,
    setIsDirty } = props
  useEffect(() => {
    setIsDirty(false)
  }, [])
  return (
    <React.Fragment>
      <div>
        {message}
      </div>
      <div className="flex flex-center amt-10 mt10">
        <textarea
          placeholder=""
          rows={6}
          className={showComplaintError ? 'input-complaint error-input' : 'input-complaint'}
          onInput={e => validateComplaint(e.target.value)}
        >
          {complaintInput}
        </textarea>
      </div>
      {complaintInput === '' && isDirty && (
        <div
          className={showComplaintError ? 'error-message apr-20 pb-2' : 'error-message o-0'}
        >
          * Please provide additional details for us to act on it.
        </div>
      )
      }
    </React.Fragment>
  )
}

const SupportBody = ({ verticalName }) => {
  const {
    fetchDetailsOfSelectedTrip,
    showTripList,
    supportInputType,
    selectedIssue,
    selectedTrip,
    updateShowFlagForTripList,
    updateTripOptionsAPIData,
    fetchOptions,
    showCallbackModal,
    showFulfillmentMessage,
    modalMessage,
    supportHeader,
    airlineInfo,
    callbackOptionsData
  } = useContext(AccountsContext)

  useEffect(() => {
    if (isTripDetailsPage()) {
      const payload = {
        tripId: getTripIdForApp(),
        level: 'L1'
      }
      fetchDetailsOfSelectedTrip(payload.tripId, payload)
      updateShowFlagForTripList(false)
      updateTripOptionsAPIData(payload)
    } else {
      triggerClevertap('support_trip_list_shown', getCommonClevertapParams())
    }
  }, [])
  const [showInputError, updateInputErrorFlag] = useState(false)
  const [showComplaintError, updateComplaintError] = useState(false)
  const [callbackInput, setInput] = useState('')
  const [complaintInput, setComplaint] = useState('')
  const [isDirty, setIsDirty] = useState(false)

  const messageFormatter = msg => {
    if (msg && msg.indexOf('$$') > -1) {
      return msg.split('$$').reverse().join(' ')
    }
    if (msg && msg.indexOf('%%') > -1) {
      return formatDate(msg)
    }
    return msg
  }
  useEffect(() => {
    setIsDirty(false)
    setInput((callbackOptionsData && callbackOptionsData[supportInputType]) || '')
    setComplaint('')
    updateComplaintError(false)
  }, [callbackOptionsData[supportInputType], callbackOptionsData.type])

  const FulfillmentModal = ({ message, info }) => (
    <React.Fragment>
      <div className="amb-15 mb15 fs-12">
        {message}
        <If condition={info}>
          <AirlineInfo info={info} modalFlag={true} />
        </If>
      </div>
    </React.Fragment>
  )

  const validateAndSetInput = (val, inputType) => {
    setInput(val)
    if (inputMap && inputMap[inputType] && inputMap[inputType].validator) {
      inputMap[inputType].validator(val, updateInputErrorFlag)
    }
  }

  const validateComplaint = val => {
    setIsDirty(true)
    setComplaint(val)
    if (val) {
      updateComplaintError(false)
    } else {
      updateComplaintError(true)
    }
  }

  const primaryButtonConfig = {
    visible: true,
    text: 'Submit',
    action: (options, requestData, inputType) => {
      setIsDirty(complaintInput.length === 0)
      const clevertapData = getCommonClevertapParams()
      const payload = { ...requestData }
      if (verticalName && verticalName.toLowerCase() === 'air') {
        payload[payload.level.toLowerCase()] = 'callback'
        payload.level = updateOptionsLevel(payload.level)
      } else {
        payload.l1 = 'callback'
        payload.tripId = getTripIdForApp()
        payload.level = updateOptionsLevel('L1')
      }
      if (options.type === 'callback') {
        payload[inputType] = callbackInput
        clevertapData.event_type = 'support_callback_widget_submit_clicked'
        triggerClevertap('Account', clevertapData)
        if (callbackInput !== '' && !showInputError) {
          fetchOptions(payload)
        } else {
          updateInputErrorFlag(true)
        }
      } else if (options.type === 'complaint') {
        payload.complaint = complaintInput
        if (complaintInput !== '') {
          fetchOptions(payload)
        } else {
          updateComplaintError(true)
        }
      }
      setComplaint('')
    }
  }
  const secondaryButtonConfig = {
    visible: true,
    text: 'Cancel',
    action: () => {
      const clevertapData = getCommonClevertapParams()
      clevertapData.event_type = 'support_callback_widget_cancel_clicked'
      triggerClevertap('Account', clevertapData)
      setInput('')
      setComplaint('')
    }
  }
  if (selectedTrip &&
    selectedTrip.flightDetails &&
    selectedTrip.flightDetails.length &&
    selectedTrip.flightDetails[0].segmentDetails &&
    selectedTrip.flightDetails[0].segmentDetails.length &&
    !showTripList) {
    selectedTrip.travelDate = selectedTrip.flightDetails[0].segmentDetails[0].departureDate
  }
  return (
    <div>
      <If condition={!showTripList}>
        <TripLabel tripDetails={selectedTrip} />
      </If>
      <If condition={selectedIssue.visible}>
        <SelectedOption label={selectedIssue.label} value={selectedIssue.value} />
      </If>
      <OptionsBox />
      <If condition={showCallbackModal && callbackOptionsData.type !== 'complaint'}>
        <div className="modal-outer">
          <Modal
            content={(
              <RequestCallbackModal
                initialValue={callbackOptionsData[supportInputType] || ''}
                callbackInput={callbackInput}
                supportInputType={supportInputType}
                showInputError={showInputError}
                validateAndSetInput={validateAndSetInput}
                message={messageFormatter(modalMessage)}
              />
            )}
            primaryButton={primaryButtonConfig}
            secondaryButton={secondaryButtonConfig}
            header={supportHeader || 'Let us help you'}
          />
        </div>
      </If>

      <If condition={showCallbackModal && callbackOptionsData.type === 'complaint'}>
        <div className="modal-outer">
          <Modal
            content={(
              <EscalationsModal
                complaintInput={complaintInput}
                showComplaintError={showComplaintError}
                validateComplaint={validateComplaint}
                message={messageFormatter(modalMessage)}
                isDirty={isDirty}
                setIsDirty={setIsDirty}
              />
            )}
            primaryButton={primaryButtonConfig}
            secondaryButton={secondaryButtonConfig}
            header={supportHeader || 'Tell us your issue'}
          />
        </div>
      </If>

      <If condition={showFulfillmentMessage}>
        <div className="modal-outer">
          <Modal
            content={(
              <FulfillmentModal
                message={messageFormatter(modalMessage)}
                info={(airlineInfo && airlineInfo.length && airlineInfo)}
              />
            )}
            primaryButton={{
              visible: false
            }}
            secondaryButton={{
              visible: false
            }}
            header={supportHeader || 'Success'}
          />
        </div>
      </If>
    </div>
  )
}

export default SupportBody
